import {Component, Input, OnInit} from '@angular/core';
import {location} from "ngx-bootstrap/utils/facade/browser";
import {it} from "selenium-webdriver/testing";
import {FoEventsService} from "../../../event/foevents.service";
import {BooKingservice} from "../../booking.service";

@Component({
  selector: 'app-registration-input',
  templateUrl: './registration-input.component.html',
  styleUrls: ['./registration-input.component.css']
})
export class RegistrationInputComponent implements OnInit {

  @Input() input1: any;
  @Input() location: any;
  @Input() event: any;
  telInputError:boolean = false;
  uploadSuccess:boolean = false;
  countries:any;
  telInput :any;

  constructor(private eventService:FoEventsService,private bookingService:BooKingservice) {}

  telInputChange(input) {
    console.log(input);
    this.input1.isValid = true;
    console.log(this.telInput);
    this.input1.value = this.telInput;
    //this.input1.value = true;
  }
  ngOnInit() {
    this.formatInput(this.input1);
    this.input1['options'] = [];
    let $ = window['jQuery'];
      $('[data-toggle="tooltip"]').tooltip();

    if(this.input1.label == 'Date de naissance' && this.event.id == 234){
      //console.log('oki event');
      this.input1.value = '2000-01-01';
    }
    if($('#telnumber-field').length){
      var input = document.querySelector("#telnumber-field");
      (<any>window).intlTelInput(input, {
        preferredCountries: ['in'],
        separateDialCode: true
      });
    }
  }


  formatInput(input) {
    input.isMandatory = parseInt(input.isMandatory);
    if (parseInt(input.isMandatory) && !input.value)
      input.isValid = false;
    else
      input.isValid = true;
    this.setTelWidth();
    if(input.inputType.toLowerCase() == 'countryselect') {
       this.loadCountries();
       this.input1.value = 'null';
    }
    this.convertPossibleAnswers(input);
    if(!input.description || input.description.length == 0)
        input.description = '';
  }

  question_has_choices(question) {
    return question.inputType.toLowerCase() == 'unikchoice' || question.inputType.toLowerCase() == 'checkbox' || question.inputType.toLowerCase() == 'radio'
  }

  convertPossibleAnswers(input) {
    if(this.question_has_choices(input)) {
       //console.log('test '+input.possible_answers);
       input['values'] = [];
       if(typeof input.possible_answers == 'string' )
         input.possible_answers = JSON.parse(input.possible_answers);
       else
         input.possible_answers = JSON.parse(JSON.stringify(input.possible_answers));

       input.value = 'null';
    }
  }



  loadCountries() {
    this.eventService.pays().then(any => {
      this.countries = any.sort(this.compare);
      }
    )
  }

  countryselectChange() {
    console.log('focused');
    this.input1.touched = true;
   if(this.input1.isMandatory &&  this.input1.value !='null'){
     this.input1.isValid = true;
   } else if(this.input1.isMandatory &&  this.input1.value =='null') {
     this.input1.isValid = false;
   }
  }


   selectChange() {
    this.input1.touched = true;
    if(this.input1.isMandatory &&  this.input1.value != 'null'){
      this.input1.isValid = true;
    } else if(this.input1.isMandatory &&  this.input1.value =='null') {
      this.input1.isValid = false;
    }
     //console.log(this.bookingService.retrieve('options'));
    if(this.input1.value == 'Demi-pension (+40€)'){
      if(this.input1.options) {
        let options = this.input1.options;
        if(!this.optionAllreadyAdded(options,this.input1.value)) {
          let option = {};
          option['name'] = 'Demi-pension';
          option['price'] = 40;
          this.input1.options.push(option);
        }
      } else {
        let options = [];
        let option = {};
        option['name'] = this.input1.value;
        option['price'] = 40;
        options.push(option);
        this.input1['options'] = options;
      }
    }else {
      if(this.input1.options) {
        for (let i=0; i< this.input1.options.length; i++) {
          if (this.input1.options[i].name == 'Demi-pension (+40€)') {
            this.input1.options.splice(i,1);
            console.log('spliced');
          }
        }
      }
    }
  }



  selectFocuse() {
    //console.log('focused');
    this.input1.touched = true;
    if(this.input1.isMandatory &&  this.input1.value != 'null'){
      this.input1.isValid = true;
    }else if(this.input1.isMandatory &&  this.input1.value =='null') {
      this.input1.isValid = false;
    }
  }

  countryselectFocuse() {
    console.log('focused');
    this.input1.touched = true;
   // console.log(this.input1.value);
    if(this.input1.isMandatory &&  this.input1.value != 'null'){
      this.input1.isValid = true;
    }else if(this.input1.isMandatory &&  this.input1.value =='null') {
      this.input1.isValid = false;
    }
  }

  setTelWidth() {
    let that = this;
    setTimeout(function () {
   let $ = window['jQuery'];
      let it = $('.iti');
      it.width('100%');
      let oinput1 = $('.oinput');
    if(oinput1.length){
          /*  console.log(oinput1);
            console.log(oinput1.attr("placeholder"));*/
        if(oinput1.attr("placeholder") && !oinput1.attr("placeholder").includes('ex'))
           oinput1.attr("placeholder","ex: "+oinput1.attr("placeholder"));
      }
    },500)

  }

  checkvalidity(el,input2) {
    input2.touched = true;
    if(parseInt(input2.isMandatory) && !input2.value  || el.validity.typeMismatch)
        input2.isValid = false;
    else
      input2.isValid = true;
  }

  checkTextareavalidity(el,input2) {
    input2.touched = true;
    if(parseInt(input2.isMandatory) && !input2.value  )
      input2.isValid = false;
    else
      input2.isValid = true;
  }


  change(el,input2) {
    console.log('changed');
    this.checkvalidity(el,input2);
    /*if (el.validity.typeMismatch) {
      input2.isValid = false;
      console.log('oki')
    }
    input2.isValid = true;*/
  }

  isInvalid(el,input2) {

  }


  onCountryChange(code) {
    let oinput1 = $('.oinput');
    if(oinput1.length){
      /*console.log(oinput1);
      console.log(oinput1.attr("placeholder"));*/
      if(oinput1.attr("placeholder") && !oinput1.attr("placeholder").includes('ex'))
        oinput1.attr("placeholder","ex: "+oinput1.attr("placeholder"));
    }
  }

  getNumber(number) {
    if(number) {
      this.input1.touched = false;
      this.input1.value = number;
    }
  }

  hasError(er) {
    if(er) {
      console.log(er)
      this.input1.isValid = true;
    }
    else {
      this.telInputError = true;
      this.input1.touched = true;
      this.input1.value = null;
      if(this.input1.isMandatory) {
        this.input1.isValid = false;
      }
    }
  }

  telInputObject(obj) {
    this.telInput = this.input1.value;
    if(this.input1.value && this.input1.value.includes('+')) {
      console.log('ok phone +');
      obj.setNumber(this.input1.value);
    }else {
      if(obj)
        obj.setCountry(this.location);
    }
  }


  text_or_email_or_number_input(input) {
    return  input.inputType == 'text' || input.inputType =='email' || input.inputType == 'number' ||  input.inputType == 'url'
      ||  input.inputType == 'date'  ||  input.inputType == 'time'
  }


  trigerFileInput() {
    let $ = window['jQuery'];
     $('#input'+this.input1.id).click();
  }

    getExtension(filename) {
    let parts = filename.split('.');
     return parts[parts.length - 1];
    }

    inputIsImage(input) {
      return input.inputType == 'file' && input.file_type == 'jpg,png';
    }

    inputIsPdf(input) {
      return input.inputType == 'file' && input.file_type == 'PDF';
    }

  inputIsZip(input) {
    return input.inputType == 'file' && input.file_type == 'ZIP';
  }

  inputIsSelection(input) {
    return input.inputType.toLowerCase() == 'countryselect' || input.inputType.toLowerCase() == 'unikchoice' ||
      input.inputType == 'radio'
  }



  /*input type file*/
  inputImagesChangeListener($event){
    this.input1.touched = true;
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    if(!this.input1.file_type.includes(this.getExtension(file.name))) {
      alert('format du fichier  invalide');
    }else {
     // console.log('ok file');
      let that = this;
      that.input1['extension'] = this.getExtension(file.name);
      myReader.onloadend = function(loadEvent: any){
          that.uploadSuccess = true;
          that.input1.value  = myReader.result;
          that.input1.isValid = true;
          //console.log(myReader.result);
      };
      myReader.readAsDataURL(file);
    }

    if(this.input1.isMandatory && !this.input1.value) {
      this.input1.isValid = false;
    }
  }


  inputPdfChangeListener($event){
    this.input1.touched = true;
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();

    if(this.getExtension(file.name) != 'pdf') {
      alert('format du fichier  invalide');
    } else {
      let that = this;
      that.input1['extension'] = 'pdf';
      myReader.onloadend = function(loadEvent: any){
        that.uploadSuccess = true;
        that.input1.isValid = true;
        that.input1.value  = myReader.result.toString().replace(/^[^,]*,/, '');
        //console.log(myReader.result);
      };
      myReader.readAsDataURL(file);
    }

    if(this.input1.isMandatory && !this.input1.value) {
      this.input1.isValid = false;
    }

  }

  inputZipChangeListener($event){
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    if(this.input1.file_type.toLowerCase() != 'zip') {
      alert('format du fichier  invalide');
    } else {
      let that = this;
      that.input1['extension'] = 'zip';
      myReader.onloadend = function(loadEvent: any){
        that.uploadSuccess = true;
        that.input1.value  = myReader.result;
        //console.log(myReader.result);
      };
      myReader.readAsDataURL(file);
    }
  }


    compare(a,b) {
      let paysA;
      let paysB;
      if(a.translations && a.translations.fr)
        paysA = a.translations.fr.toUpperCase();
      if(b.translations && b.translations.fr)
        paysB = b.translations.fr.toUpperCase();

      let comparison = 0;
      if (paysA > paysB) {
       comparison = 1;
      } else if (paysA < paysB) {
       comparison = -1;
     }
      return comparison;
  }

  optionAllreadyAdded(options,name){
    for(let i = 0 ;i<options.length; i++){
      if(options[i].name == name)
        return true;
    }
    return false;
  }

  checkboxonChange(resp:string, isChecked: boolean) {
    this.bookingService.removeItem('options');
    this.input1.touched = true;
    if(isChecked) {
        console.log('choosed');
        if(this.input1.label == 'Option annulation'){
          //console.log('choosed');
          if(this.input1.options) {
            if(!this.optionAllreadyAdded(this.input1.options,resp)) {
              let option = {};
              option['name'] = 'assurance annulation';
              option['price'] = 60;
              this.input1.options.push(option);
            }
          } else {
            let options = [];
            let option = {};
            option['name'] = resp;
            option['price'] = 60;
            options.push(option);
            this.input1['options'] = options;
          }

        }
      this.input1.values.push(resp);
      this.input1.isValid = true;
    } else {
      let index = this.input1.values.indexOf(resp);
      this.input1.values.splice(index,1);
      if(this.input1.isMandatory && this.input1.values.length == 0) {
        this.input1.isValid = false;
      }
      if(this.input1.options) {
        for (let i=0; i< this.input1.options.length; i++) {
          if (this.input1.options[i].name ==  this.input1.label && this.input1.label == 'Option annulation') {
            this.input1.options.splice(i,1);
            console.log('spliceed')
          }
        }
      }
    }
  }

 radioonChange(resp:string, isChecked: boolean) {
   this.input1.touched = true;
    if(isChecked) {
      //console.log(resp);
      this.input1.isValid = true;
      this.input1.value = resp;
    }
  }


}
